var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { asApiScoreAttribute, asPassportMetadata, asPassportStats, asScore, asScoresResponse, asSkinMetadata, extendedCast, } from '@arcxmoney/arcx-core';
import { asArray, asNumber, asObject, asString } from '@restless/sanitizers';
import axios from 'axios';
import { asFullScore, asScoreWithProof } from '../types';
import { handleHttpResponse } from '../utils';
import { sortByTitle } from '../utils/sortByName';
var ArcxApi = /** @class */ (function () {
    function ArcxApi(arcxUrl, protocol, defaultChainId, defaultAccount) {
        this.arcxUrl = arcxUrl;
        this.protocol = protocol;
        this.defaultChainId = defaultChainId;
        this.defaultAccount = defaultAccount;
    }
    ArcxApi.prototype.getContractScoreProof = function (protocol) {
        if (protocol === void 0) { protocol = this.protocol; }
        return __awaiter(this, void 0, void 0, function () {
            var score;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getScoreProof(this.defaultAccount, protocol)];
                    case 1:
                        score = _a.sent();
                        if (!score.score) {
                            return [2 /*return*/];
                        }
                        return [2 /*return*/, extendedCast(score, asScoreWithProof, 'Contract Score Proof')];
                }
            });
        });
    };
    ArcxApi.prototype.getUserScoresWithMetadata = function (account) {
        if (account === void 0) { account = this.defaultAccount; }
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!account) {
                            throw new Error('ArcxApi.getUserScoresWithMetadata: account is required');
                        }
                        return [4 /*yield*/, this.getScoresForAccount(account, true)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, extendedCast(response, asArray(asFullScore), 'User scores with metadata')];
                }
            });
        });
    };
    ArcxApi.prototype.getAllScoreAttributes = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response, protocolStats;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.fetchFromApi('/v1/protocols', this.getCrossChainFetchOptions())];
                    case 1:
                        response = _a.sent();
                        protocolStats = extendedCast(response, asProtocolsStats, 'All Protocol Stats');
                        return [2 /*return*/, protocolStats.data];
                }
            });
        });
    };
    ArcxApi.prototype.getScoreAttributes = function (protocol) {
        return __awaiter(this, void 0, void 0, function () {
            var response, protocolStats;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.fetchFromApi("/v1/protocols?names=".concat(protocol), this.getCrossChainFetchOptions())];
                    case 1:
                        response = _a.sent();
                        protocolStats = extendedCast(response, asProtocolsStats, 'Protocol Stats');
                        return [2 /*return*/, protocolStats.data[0]];
                }
            });
        });
    };
    ArcxApi.prototype.getFullScoresWithAttributes = function (account) {
        if (account === void 0) { account = this.defaultAccount; }
        return __awaiter(this, void 0, void 0, function () {
            var res, _a, userScores, scoresAttributes;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!account) {
                            throw new Error('ArcxApi.getUserScoresAndAttributes: account is required');
                        }
                        res = [];
                        return [4 /*yield*/, Promise.all([
                                this.getUserScoresWithMetadata(account),
                                this.getAllScoreAttributes(),
                            ])];
                    case 1:
                        _a = _b.sent(), userScores = _a[0], scoresAttributes = _a[1];
                        scoresAttributes.forEach(function (attributes) {
                            var score = userScores.find(function (score) { return score.protocol === attributes.name; });
                            var scoreWithAttributes;
                            if (!score) {
                                scoreWithAttributes = {
                                    account: account,
                                    protocol: attributes.name,
                                    score: '',
                                    metadata: {
                                        rank: 0,
                                        percentile: 0,
                                        explanations: [],
                                    },
                                    attributes: attributes,
                                };
                            }
                            else {
                                scoreWithAttributes = __assign(__assign({}, score), { attributes: attributes });
                            }
                            res.push(scoreWithAttributes);
                        });
                        return [2 /*return*/, res];
                }
            });
        });
    };
    ArcxApi.prototype.getPassportStats = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.fetchFromApi('/statistics')];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, extendedCast(response, asPassportStats, 'Passport Stats')];
                }
            });
        });
    };
    ArcxApi.prototype.getPassportMetadata = function (account) {
        if (account === void 0) { account = this.defaultAccount; }
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!account) {
                            throw new Error('ArcxApi.getPassportMetadata: account is required');
                        }
                        return [4 /*yield*/, this.fetchFromApi("/passports/".concat(account))];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, extendedCast(response, asPassportMetadata, 'Passport Metadata')];
                }
            });
        });
    };
    ArcxApi.prototype.getOwnedSkins = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.defaultAccount) {
                            throw new Error('ArcxApi.getOwnedSkins: defaultAccount is required (not connected)');
                        }
                        return [4 /*yield*/, this.fetchFromApi("/passports/ownedSkins/".concat(this.defaultAccount))];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, extendedCast(response, asArray(asSkinMetadata), 'Owned Skins')];
                }
            });
        });
    };
    ArcxApi.prototype.getAllSkins = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response, allSkins;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.fetchFromApi('/skins')];
                    case 1:
                        response = _a.sent();
                        allSkins = extendedCast(response, asArray(asSkinMetadata), 'Skin Metadata');
                        return [2 /*return*/, sortByTitle(allSkins)];
                }
            });
        });
    };
    /**
     * Posts the given image to twitter and returns an URL to pass to the
     * Twitter share button
     * @param data Data of image to share
     */
    ArcxApi.prototype.getShareToTwitterURL = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.fetchFromApi('/twitter/get-share-to-twitter-url', {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                            },
                            body: JSON.stringify({
                                imageData: data,
                            }),
                        })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, extendedCast(response, asString, 'Twitter URL')];
                }
            });
        });
    };
    ArcxApi.prototype.postClaimPassport = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            var res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, axios.post("".concat(this.arcxUrl, "/passports/claim"), args)];
                    case 1:
                        res = _a.sent();
                        return [2 /*return*/, res.status === 201];
                }
            });
        });
    };
    ArcxApi.prototype.postChangeSkin = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            var res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, axios.post("".concat(this.arcxUrl, "/passports/apply-skin"), args, this.getCrossChainFetchOptions())];
                    case 1:
                        res = _a.sent();
                        return [2 /*return*/, res.status === 201];
                }
            });
        });
    };
    ArcxApi.prototype.postPendingImpactTx = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            var res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, axios.post("".concat(this.arcxUrl, "/borrow/submit-pending-impact"), args, this.getCrossChainFetchOptions())];
                    case 1:
                        res = _a.sent();
                        return [2 /*return*/, res.status === 201];
                }
            });
        });
    };
    ArcxApi.prototype.getScoresByProtocol = function (protocol, limit, offset) {
        if (limit === void 0) { limit = 25; }
        if (offset === void 0) { offset = 0; }
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.fetchFromApi("/v1/scores?format=full&protocol=".concat(protocol, "&limit=").concat(limit, "&offset=").concat(offset, "&sortBy=rank"))];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, extendedCast(response, asScoresResponse, "getScoresByProtocol ".concat(protocol))];
                }
            });
        });
    };
    //
    // Private methods
    //
    ArcxApi.prototype.fetchFromApi = function (url, args) {
        return __awaiter(this, void 0, void 0, function () {
            var chainHeaders;
            return __generator(this, function (_a) {
                chainHeaders = this.getCrossChainFetchOptions();
                return [2 /*return*/, fetch("".concat(this.arcxUrl).concat(url), args ? __assign(__assign({}, args), { headers: __assign(__assign({}, args.headers), chainHeaders.headers) }) : chainHeaders).then(handleHttpResponse)];
            });
        });
    };
    ArcxApi.prototype.getCrossChainFetchOptions = function () {
        return {
            headers: {
                chainid: this.defaultChainId,
            },
        };
    };
    ArcxApi.prototype.getScoreProof = function (account, protocol) {
        if (protocol === void 0) { protocol = this.protocol; }
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!account) {
                            throw new Error('ArcxApi.getScoreProof: account is required');
                        }
                        return [4 /*yield*/, this.fetchFromApi("/scores/".concat(account, "/").concat(protocol), this.getCrossChainFetchOptions())];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, extendedCast(response, asScore, 'Score proof')];
                }
            });
        });
    };
    ArcxApi.prototype.getScoresForAccount = function (account, includeMetadata) {
        if (account === void 0) { account = this.defaultAccount; }
        if (includeMetadata === void 0) { includeMetadata = false; }
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.fetchFromApi("/scores/".concat(account, "?metadata=").concat(includeMetadata), this.getCrossChainFetchOptions())];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    return ArcxApi;
}());
export { ArcxApi };
var asProtocolsStats = asObject({
    total: asNumber,
    current: asNumber,
    data: asArray(asApiScoreAttribute),
});
//# sourceMappingURL=ArcxApi.js.map